/**
 * Cart Subscription Upsell — External Script
 * Injects subscription <select> elements into both the AJAX cart drawer
 * AND the /cart page. Manages the upsell banner. Zero core file mods.
 *
 * Drawer: hooks into afterCartLoad.ajaxCart event
 * Cart page: runs on DOMContentLoaded for /cart
 */
(function ($) {
  "use strict";

  // ---- Product data cache (persists across cart rebuilds) ----
  var productCache = {};
  var CAMPAIGN_DISCOUNT_CODE = "FREE_BULLY_STICKS";
  var DEFAULT_BANNER_MESSAGE = "Subscribe & Get 15% OFF";
  var CAMPAIGN_BANNER_MESSAGE = "Subscribe and get 15% + FREE Bully Sticks (5ct) for LIFE";
  var CAMPAIGN_ELIGIBILITY_MESSAGE =
    "Woohoo, you're getting a lifetime of FREE Bully Sticks (5ct). They'll be added to your order after checkout.";

  function normalizeValue(value) {
    return $.trim((value || "").toString()).toUpperCase();
  }

  function getCookieValue(name) {
    var cookieParts = document.cookie ? document.cookie.split(";") : [];

    for (var i = 0; i < cookieParts.length; i++) {
      var cookie = $.trim(cookieParts[i]);

      if (cookie.indexOf(name + "=") === 0) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }

    return "";
  }

  function hasCampaignDiscountCookie() {
    return normalizeValue(getCookieValue("discount_code")) === CAMPAIGN_DISCOUNT_CODE;
  }

  function hasCampaignDiscount(cart) {
    if (hasCampaignDiscountCookie()) return true;

    if (cart && cart.discount_codes && cart.discount_codes.length) {
      for (var i = 0; i < cart.discount_codes.length; i++) {
        if (normalizeValue(cart.discount_codes[i].code) === CAMPAIGN_DISCOUNT_CODE) {
          return true;
        }
      }
    }

    return false;
  }

  function hasNonSubscriptionItems(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;

    var hasNonSub = false;
    $.each(cart.items, function (i, item) {
      if (!item.selling_plan_allocation) {
        hasNonSub = true;
        return false;
      }
    });

    return hasNonSub;
  }

  function hasSubscriptionItems(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;

    var hasSub = false;
    $.each(cart.items, function (i, item) {
      if (item.selling_plan_allocation) {
        hasSub = true;
        return false;
      }
    });

    return hasSub;
  }

  function buildBannerInnerHTML() {
    return (
      '<span class="cart-upsell-banner__content">' +
      '<span class="cart-upsell-banner__text js-cart-upsell-banner-text">' +
      DEFAULT_BANNER_MESSAGE +
      "</span>" +
      '<span class="cart-upsell-banner__tooltip-wrap">' +
      '<button type="button" class="cart-upsell-banner__tooltip-trigger" aria-label="Campaign offer details">i</button>' +
      '<span class="cart-upsell-banner__tooltip" role="tooltip">For a limited time, get a lifetime free Bully Sticks (5ct). Offer limited to one per customer.</span>' +
      "</span>" +
      "</span>"
    );
  }

  function ensureBannerMarkup($banner) {
    if (!$banner.length) return;

    if (!$banner.find(".js-cart-upsell-banner-text").length) {
      $banner.html(buildBannerInnerHTML());
    }
  }

  function setBannerContent($banner, isCampaignActive) {
    if (!$banner.length) return;

    ensureBannerMarkup($banner);

    var defaultMessage =
      $banner.attr("data-default-message") || DEFAULT_BANNER_MESSAGE;
    var campaignMessage =
      $banner.attr("data-campaign-message") || CAMPAIGN_BANNER_MESSAGE;

    $banner
      .toggleClass("is-campaign", !!isCampaignActive)
      .find(".js-cart-upsell-banner-text")
      .text(isCampaignActive ? campaignMessage : defaultMessage);
  }

  function updateCampaignDiscountMessage($scope, isCampaignActive, showEligibility) {
    if (!$scope || !$scope.length) return;

    var hiddenCount = 0;

    $scope.find("[data-discount-title]").each(function () {
      var $discountRow = $(this);
      var isCampaignDiscount =
        normalizeValue($discountRow.attr("data-discount-title")) ===
        CAMPAIGN_DISCOUNT_CODE;

      if (isCampaignDiscount) {
        $discountRow.hide();
        hiddenCount++;
      } else {
        $discountRow.show();
      }
    });

    $scope.find(".js-campaign-eligibility-note").remove();

    if (showEligibility) {
      $scope.find(".js-cart-discount-summary").first().append(
        '<p class="cart__footer-campaign-note js-campaign-eligibility-note">' +
          CAMPAIGN_ELIGIBILITY_MESSAGE +
          '<span class="cart-eligibility__tooltip-wrap">' +
          '<button type="button" class="cart-eligibility__tooltip-trigger" aria-label="Campaign offer details">i</button>' +
          '<span class="cart-eligibility__tooltip" role="tooltip">For a limited time, get a lifetime free Bully Sticks (5ct). Offer limited to one per customer.</span>' +
          "</span>" +
          "</p>"
      );
    }
  }

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return $.Deferred().resolve(productCache[handle]).promise();
    }
    return $.getJSON("/products/" + handle + ".js").then(function (product) {
      productCache[handle] = product;
      return product;
    });
  }

  // ---- Get selling plan options for a variant ----
  function getSellingPlanOptions(product, variantId) {
    var variant = null;
    $.each(product.variants, function (i, v) {
      if (v.id == variantId) {
        variant = v;
        return false;
      }
    });
    if (!variant) return [];

    var options = [];
    if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
      $.each(product.selling_plan_groups, function (gi, group) {
        $.each(group.selling_plans, function (pi, plan) {
          var available = false;
          if (variant.selling_plan_allocations) {
            $.each(variant.selling_plan_allocations, function (ai, alloc) {
              if (alloc.selling_plan_id == plan.id) {
                available = true;
                return false;
              }
            });
          }
          if (available) {
            options.push({ id: plan.id, name: plan.name });
          }
        });
      });
    }
    return options;
  }

  // ---- Build <select> HTML ----
  function buildSelectHTML(line, currentPlanId, options, currentPlanName) {
    var isInline = !!currentPlanId;
    var html =
      '<div class="cart-subscription-container' +
      (isInline ? " cart-subscription-container--inline" : "") +
      '">';

    if (!currentPlanId) {
      // It's currently a one-time purchase. Default to "Subscribe & Save"
      html +=
        '<select class="cart-subscription-select" data-line="' + line + '">';
      html +=
        '<option value="one-time" disabled selected hidden>Subscribe & Get 15% OFF</option>';
      $.each(options, function (i, opt) {
        html += '<option value="' + opt.id + '">' + opt.name + "</option>";
      });
      html += "</select>";
    } else {
      // It's a subscription. Render inline label and frequency dropdown.
      var prefix = "Delivered every";
      if (currentPlanName) {
        var match = currentPlanName.match(/^(.*?every)\s+/i);
        if (match) prefix = match[1];
      }

      var svgIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="2048" height="2048" viewBox="0 0 2048 2048" fill="currentColor" style="width:16px;height:16px;margin-right:4px;vertical-align:text-bottom;"><path d="M256 1536h768v128H128V128h256V0h128v128h896V0h128v128h256v896h-128V640H256zm0-1280v256h1408V256h-128v128h-128V256H512v128H384V256zm1792 896v384h-384v-128h190q-45-60-112-94t-142-34q-59 0-111 20t-95 55t-70 85t-38 107l-127-22q14-81 54-149t98-118t133-78t156-28q91 0 174 35t146 102v-137zm-448 768q58 0 111-20t95-55t70-85t38-107l127 22q-14 81-54 149t-98 118t-133 78t-156 28q-91 0-174-35t-146-102v137h-128v-384h384v128h-190q45 60 112 94t142 34"/></svg>';

      html +=
        '<span class="cart-subscription-inline-label" style="display:flex;align-items:center;">' +
        svgIcon +
        prefix +
        " </span>";
      html +=
        '<select class="cart-subscription-select cart-subscription-select--inline" data-line="' +
        line +
        '">';

      $.each(options, function (i, opt) {
        var sel = currentPlanId == opt.id ? " selected" : "";
        var shortName = opt.name;
        var m = opt.name.match(/every\s+(.*)/i);
        if (m) shortName = m[1];

        html +=
          '<option value="' +
          opt.id +
          '"' +
          sel +
          ">" +
          shortName +
          "</option>";
      });
      html += "</select>";
    }

    html += "</div>";
    return html;
  }

  // ---- Banner visibility ----
  function updateBanner(cart) {
    var $banner = $(".js-cart-upsell-banner");
    if (!$banner.length) return;

    var hasNonSub = hasNonSubscriptionItems(cart);
    var hasSub = hasSubscriptionItems(cart);
    var showBanner = hasNonSub && !hasSub;
    var isCampaignActive = showBanner && hasCampaignDiscount(cart);

    setBannerContent($banner, isCampaignActive);

    if (showBanner) {
      $banner.addClass("is-visible");
      var bannerHeight = $banner.outerHeight() || 36;
      $banner
        .closest(".ajaxcart-draw")
        .css("--banner-height", bannerHeight + "px")
        .addClass("has-upsell-banner");
    } else {
      $banner.removeClass("is-visible");
      $banner
        .closest(".ajaxcart-draw")
        .css("--banner-height", "0px")
        .removeClass("has-upsell-banner");
    }
  }

  // ===========================================================
  // AJAX CART DRAWER — hooks into afterCartLoad.ajaxCart
  // ===========================================================
  function onDrawerCartLoaded(e, cart) {
    updateBanner(cart);

    var hasSub = hasSubscriptionItems(cart);
    var hasCampaignCode = hasCampaignDiscount(cart);
    updateCampaignDiscountMessage(
      $(".ajaxcart-draw"),
      hasSub && hasCampaignCode,
      hasSub && hasCampaignCode
    );

    if (!cart || !cart.items || !cart.items.length) return;

    // Collect unique handles
    var handles = [];
    $.each(cart.items, function (i, item) {
      if (item.handle && handles.indexOf(item.handle) === -1) {
        handles.push(item.handle);
      }
    });

    var fetches = $.map(handles, function (h) {
      return fetchProduct(h);
    });

    $.when.apply($, fetches).then(function () {
      // Target: .o-layout__item.u-2\/3 inside each .ajaxcart__product
      var $rows = $(".ajaxcart__product");

      $.each(cart.items, function (i, cartItem) {
        var product = productCache[cartItem.handle];
        if (!product) return;

        var options = getSellingPlanOptions(product, cartItem.variant_id);
        if (options.length === 0) return;

        var $row = $rows.eq(i);
        if (!$row.length) return;

        // Inject into the product info column
        var $infoCol = $row.find(".o-layout__item.u-2\\/3");
        if (!$infoCol.length) return;
        if ($infoCol.find(".cart-subscription-container").length) return; // don't double-inject

        var currentPlanId = cartItem.selling_plan_allocation
          ? cartItem.selling_plan_allocation.selling_plan.id
          : null;
        var currentPlanName = cartItem.selling_plan_allocation
          ? cartItem.selling_plan_allocation.selling_plan.name
          : null;

        // Hide original text
        if (currentPlanName) {
          $infoCol
            .find("p")
            .filter(function () {
              return $(this).text().trim() === currentPlanName.trim();
            })
            .hide();
        }

        $infoCol.append(
          buildSelectHTML(i + 1, currentPlanId, options, currentPlanName)
        );
      });
    });
  }

  $("body").on("afterCartLoad.ajaxCart", onDrawerCartLoaded);

  // ===========================================================
  // CART PAGE (/cart) — runs on DOMContentLoaded
  // ===========================================================
  function initCartPage() {
    var $cartProducts = $(".cart__product");
    if (!$cartProducts.length) return;

    $.getJSON("/cart.js", function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;

      // Inject banner on cart page
      var $sectionTitle = $(".section--cart .section__title");
      var hasNonSub = hasNonSubscriptionItems(cart);
      var hasSub = hasSubscriptionItems(cart);
      var showBanner = hasNonSub && !hasSub;
      var hasCampaignCode = hasCampaignDiscount(cart);
      var isCampaignActive = showBanner && hasCampaignCode;

      if ($sectionTitle.length) {
        var $cartPageBanner = $sectionTitle.next(".js-cart-upsell-banner");

        if (showBanner) {
          if (!$cartPageBanner.length) {
            $sectionTitle.after(
              '<div class="cart-upsell-banner js-cart-upsell-banner is-visible" data-default-message="Subscribe &amp; Get 15% OFF" data-campaign-message="Subscribe and get 15% + FREE Bully Sticks (5ct) for LIFE">' +
                buildBannerInnerHTML() +
                "</div>"
            );
            $cartPageBanner = $sectionTitle.next(".js-cart-upsell-banner");
          }

          setBannerContent($cartPageBanner, isCampaignActive);
          $cartPageBanner.addClass("is-visible");
        } else if ($cartPageBanner.length) {
          $cartPageBanner.remove();
        }
      }

      updateCampaignDiscountMessage(
        $(".section--cart"),
        isCampaignActive,
        hasSub && hasCampaignCode
      );

      // Collect unique handles
      var handles = [];
      $.each(cart.items, function (i, item) {
        if (item.handle && handles.indexOf(item.handle) === -1) {
          handles.push(item.handle);
        }
      });

      var fetches = $.map(handles, function (h) {
        return fetchProduct(h);
      });

      $.when.apply($, fetches).then(function () {
        $.each(cart.items, function (i, cartItem) {
          var product = productCache[cartItem.handle];
          if (!product) return;

          var options = getSellingPlanOptions(product, cartItem.variant_id);
          if (options.length === 0) return;

          var $row = $cartProducts.eq(i);
          if (!$row.length) return;

          // Cart page: inject into .o-layout__item.u-2/3 (product info column)
          var $infoCol = $row.find(".o-layout__item.u-2\\/3");
          if (!$infoCol.length) return;
          if ($infoCol.find(".cart-subscription-container").length) return;

          var currentPlanId = cartItem.selling_plan_allocation
            ? cartItem.selling_plan_allocation.selling_plan.id
            : null;
          var currentPlanName = cartItem.selling_plan_allocation
            ? cartItem.selling_plan_allocation.selling_plan.name
            : null;

          // Hide original text
          if (currentPlanName) {
            $infoCol
              .find("p")
              .filter(function () {
                return $(this).text().trim() === currentPlanName.trim();
              })
              .hide();
          }

          $infoCol.append(
            buildSelectHTML(i + 1, currentPlanId, options, currentPlanName)
          );
        });
      });
    });
  }

  $(document).ready(function () {
    if (window.location.pathname === "/cart") {
      initCartPage();
    }
  });

  // ===========================================================
  // SELECT CHANGE HANDLER (works for both drawer and cart page)
  // ===========================================================
  $(document).on("change", ".cart-subscription-select", function () {
    var $select = $(this);
    var selectedVal = $select.val();
    var line = $select.data("line");

    $("body").addClass("drawer--is-loading");

    var payload;
    if (selectedVal === "one-time") {
      payload = JSON.stringify({ line: line, selling_plan: "" });
    } else {
      payload = JSON.stringify({
        line: line,
        selling_plan: parseInt(selectedVal),
      });
    }

    $.ajax({
      type: "POST",
      url:
        (typeof theme !== "undefined" && theme.routes
          ? theme.routes.cartChangeUrl
          : "/cart/change") + ".js",
      data: payload,
      contentType: "application/json",
      dataType: "json",
      success: function () {
        // If we're in the drawer, use ajaxCart.load() for full rebuild
        if (typeof ajaxCart !== "undefined" && ajaxCart.load) {
          ajaxCart.load();
        }
        // If we're on the cart page, just reload the page for a clean state
        if (window.location.pathname === "/cart") {
          location.reload();
        }
      },
      error: function () {
        $("body").removeClass("drawer--is-loading");
      },
    });
  });
})(jQuery);
